<template>
<header class="flex flex-wrap py-2 pl-2 pr-2 justify-content-between flex-row surface-border border-bottom-2 ">
    <div class="flex flex-wrap flex-row align-items-center"> 
      <a href="/" class="flex align-items-center md:mb-0 text-gray-900 no-underline" style="width:230px">
        <img src="/img/pifema-logo-dark.svg" width="130">
        <span class="text-2xl ml-2 " style="padding-top: 0.2rem">SPOT</span>
      </a>
      <a v-if="store.selectModul != ''" v-ripple class="cursor-pointer block lg:hidden text-700 mr-3 mt-1 p-ripple"    
          v-styleclass="{ selector: '#sidebar-1', enterClass: 'hidden', enterActiveClass: 'fadeinleft',
                      leaveToClass:'hidden', leaveActiveClass:'fadeoutleft', hideOnOutsideClick:true}">
        <i class="pi pi-bars text-4xl"></i>
      </a>
    </div>

    <div  class="flex flex-row justify-content-between align-items-center relative lg:static">
       
            <a v-ripple class="cursor-pointer block lg:hidden text-700 p-ripple" 
               v-styleclass="{ selector:'.headermenu', enterClass:'hidden', enterActiveClass:'fadein', leaveToClass:'hidden', leaveActiveClass:'fadeout', hideOnOutsideClick:true}">
              <i class="pi pi-ellipsis-v text-2xl"></i>
            </a>
            <ul  class="min-w-max headermenu list-none p-0 m-0 hidden lg:flex lg:align-items-center select-none lg:flex-row surface-section border-1 lg:border-none surface-border right-0 top-100 z-2 shadow-2 lg:shadow-none absolute lg:static">

                <li>
                  <a v-if="store.token != '' " href="javascript:void(0);"  @click="setRoute('mod-orders/orders')" class="hidden lg:block mr-2">
                    <PrimevueButton label="Objednávky" severity="primary" text raised />
                  </a>
                  
                  <a v-if="store.token != '' "  href="javascript:void(0);"  @click="setRoute('mod-orders/orders')" v-ripple class="block lg:hidden no-underline flex p-2 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer
                          transition-duration-150 transition-colors p-ripple">
                  
                    <i class=" pi pi-book text-base mr-2"></i>
                    <span class=" font-medium">Objednávky</span>
  
                  </a>
                </li>

                <li>
                  <a v-if="store.token != '' && (store.user.admin === true || store.user.department.id == 3 || store.user.department.id == 1)" href="javascript:void(0);"  @click="setRoute('mod-stock')" class="hidden lg:block mr-2">
                    <PrimevueButton label="Sklad" severity="primary" text raised />
                  </a>
                  
                  <a v-if="store.token != '' && (store.user.admin === true || store.user.department.id == 3 || store.user.department.id == 1)"  href="javascript:void(0);"  @click="setRoute('mod-stock')" v-ripple class="block lg:hidden no-underline flex p-2 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer 
                          transition-duration-150 transition-colors p-ripple">
                  
                    <i class=" pi pi-warehouse text-base mr-2"></i>
                    <span class=" font-medium">Sklad</span>
  
                  </a>
                </li>

                <li>
                    <router-link v-if="store.token != '' && store.user.admin === true" to="/admin/users" class="hidden lg:block mr-2">
                       <PrimevueButton label="Užívatelia" severity="info" text raised />
                    </router-link>
                    <router-link v-if="store.token != '' && store.user.admin === true" to="/admin/users" v-ripple class="block lg:hidden no-underline flex p-2 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer 
                            transition-duration-150 transition-colors p-ripple">
                    
                      <i class=" pi pi-users text-base mr-2"></i>
                      <span class=" font-medium">Užívatelia</span>
                    </router-link>
                </li>
                <li>
                  <a href="javascript:void(0);"  @click="logout()" class="hidden lg:block mr-2">
                     <PrimevueButton label="Odhlásiť sa" plain text raised />
                  </a>
                  <a href="javascript:void(0);"  @click="logout()" v-ripple class="block lg:hidden no-underline flex p-2 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer 
                            transition-duration-150 transition-colors p-ripple">

                    <i class=" pi pi-power-off text-base mr-2"></i>
                    <span class=" font-medium">Odhlásiť sa</span>
     
                  </a>
                </li>    
                <li>
                  <router-link v-if="store.token != ''" :to="`/admin/users/${this.store.user.id}`" class="hidden lg:block mr-2">
                     <PrimevueButton :label="this.store.user.firstName ?? ''" severity="info" text raised class="font-medium text-base text-800"/>
                  </router-link>
                  <router-link v-if="store.token != ''" :to="`/admin/users/${this.store.user.id}`" v-ripple class="block lg:hidden no-underline flex p-2 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer 
                            transition-duration-150 transition-colors p-ripple">
 
                    <i class=" pi pi-user text-base mr-2"></i>
                    <span class=" font-medium">{{this.store.user.firstName}} {{this.store.user.lastName}}</span>
     
                  </router-link>
                </li>            
            </ul>
 
      </div>
</header>
<div class="flex relative lg:static surface-ground">
  <div v-if="store.selectModul != ''" id="sidebar-1" class="surface-section hidden lg:block flex-shrink-0 absolute 
             lg:static left-0 top-0 z-5 border-right-1 surface-border select-none" style="width:230px" :style="{ height: `${vh - 165}px` }">
     <div class="flex-column flex">
         <div class="overflow-y-auto ">
            <ManageOrders v-if="store.selectModul == 'mod-orders'"/>
            <ManageStock v-if="store.selectModul == 'mod-stock'"/>
          </div>
      </div>
  </div>
  <div class="flex flex-column relative flex-auto surface-50">
      <router-view /> 
  </div>
</div>             
</template>

<script lang="ts">
import {store} from "@/components/store";
import Security from './security';

import notie from "notie/dist/notie";
import router from "@/router";
import PrimevueButton from 'primevue/button';
//import Utils from '@/components/utils';
import {emiter} from '../main';
import ManageOrders from '@/components/Orders.vue';
import ManageStock from '@/components/Stock.vue';

export default {
  components:{
    PrimevueButton,
    ManageOrders,
    ManageStock,
  },
  //props: {
  //     token: String,
  //},
  data() {
    return {
      store,
      vh: 0,
    }
  },
  //computed: {
  //  Utils() {
  //    return Utils
  //  },
  //},
  beforeMount() {
  //  if (Security.requireToken()){
  //     this.fetchData()
  //  }
   console.log(this.$route)
   //store.selectModul = this.$route.path.split("/")[1]
   this.setDynamicHeight(); 
   // Aktualizácia výšky pri zmene veľkosti okna
   window.addEventListener("resize", this.setDynamicHeight);
  },
  mounted() {
    console.log("Route params:", this.$route);
  },
  beforeUnmount() {
  //  this.stopCountingMessages()
    emiter.off('reload',this.getCountOfMessages);
    window.removeEventListener("resize", this.setDynamicHeight);
  },

  methods: {
    setDynamicHeight() {
      this.vh = window.innerHeight; // Nastavenie viditeľnej výšky
    },

    setRoute(param: string){
      store.selectModul = param;
      router.push({path: '/'+param})
    },

    logout() {
      const payload = {
        token: store.token
      }
      
      fetch(store.Api_url+'/logout', Security.requestOptions("POST",payload))
          .then((response) => response.json)
          .then((response) => {
            if ((response as any).error) {
              //console.log((response as any).message)

            } else {

              // premaze sa token a user na frontende
              store.token = ""
              store.admin = false
              store.user = {
                    id: 0,
                    department: {id:0, name:""},
                    firstName: "",
                    lastName: "",
                    email: "",
                    admin: false,
              }
              store.selectModul = ""
              // premazu sa data
              document.cookie = '_e-firma_data=; Path/;' +
                  ";SameSite=strict; Secure;" +
                  'Expires= Thu, 01 Jan 1970 00:00:01 GMT;'


              // vypise sa hlaska
              notie.alert({
                type: 'warning',
                text: "Úspešne ste sa odhlásili",
                position: "bottom"
              })

 
              
            }
          }).finally(() => {
            emiter.off('reload')
            localStorage.clear();
            sessionStorage.clear();
            // jednoduche presmerovanie po odhlaseni sa
            //router.push({path: '/login'})
            this.$router.push('/login');
          });
    }
  }
}
</script>
<style scoped>

</style>